import { news } from '@/data/news';
import { atom } from 'nanostores';

export class NewsStore {
  $pageIndex = atom(0);

  $isPrevActive = atom(false);

  $isNextActive = atom(false);

  $news = atom([]);

  $newsSlide = atom([]);

  lastNewsCount = 9;

  newsPerPage = 3;

  store;

  constructor(store) {
    this.store = store;
  }

  get maxPageCount() {
    return Math.ceil(this.lastNewsCount / this.newsPerPage);
  }

  init() {
    this.$news.set(news.slice(0, this.lastNewsCount));
    this.updateState();
  }

  setPageIndex(value) {
    this.$pageIndex.set(value);
    this.updateState();
  }

  nextPage() {
    if (this.$isNextActive.get()) this.setPageIndex(this.$pageIndex.get() + 1);
  }

  prevPage() {
    if (this.$isPrevActive.get()) this.setPageIndex(this.$pageIndex.get() - 1);
  }

  updateState() {
    const index = this.$pageIndex.get();
    this.$isPrevActive.set(index > 0);
    this.$isNextActive.set(index < this.maxPageCount - 1);

    const from = this.$pageIndex.get() * this.newsPerPage;
    const to = from + this.newsPerPage;
    this.$newsSlide.set(this.$news.get().slice(from, to));
  }
}
